/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * リード（PII）項目型。設問 `leadFieldKind` が非nullなら PII リード項目で、入力値はリード表へ
隔離保存される（questionType は無視・EMAIL は形式検証を継承・ADR-0012・#262）。
 */
export type LeadFieldKind = (typeof LeadFieldKind)[keyof typeof LeadFieldKind]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeadFieldKind = {
  EMAIL: 'EMAIL',
  NAME: 'NAME',
  COMPANY: 'COMPANY',
  PHONE: 'PHONE',
  DEPARTMENT: 'DEPARTMENT',
  TEXT: 'TEXT',
} as const
